import { request as requester } from 'sonata-react-components';

import type {
  DoohAudienceProfilingResponse,
  DoohReportLogo,
  DoohReportResponse,
  DoohReportSettingsResponse
} from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

export async function getDoohReport(lineItemId: string, userId: string): Promise<DoohReportResponse> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}doohReport/${lineItemId}/report`, {
    data: { userId },
    method: 'POST'
  });
}

export async function getDoohReportAvailability(lineItemId: string): Promise<{ available: boolean }> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}doohReport/${lineItemId}/reportAvailability`, {
    method: 'GET'
  });
}

export async function getDoohAudienceProfiling(
  lineItemId: string,
  userId: string
): Promise<DoohAudienceProfilingResponse> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}doohReport/${lineItemId}/audienceProfiling`, {
    data: { userId },
    method: 'POST'
  });
}

export async function getDoohReportSettings(lineItemId: string): Promise<DoohReportSettingsResponse> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}doohReport/${lineItemId}/settings`, {
    method: 'GET'
  });
}

export async function uploadDoohReportLogo(lineItemId: string, rawFile: File): Promise<{ logo: DoohReportLogo }> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}doohReport/${lineItemId}/logo`, {
    data: new Blob([rawFile]),
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'POST',
    params: {
      name: rawFile.name
    }
  });
}

export async function resetDoohReportLogo(lineItemId: string): Promise<{ logo: null }> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}doohReport/${lineItemId}/logo`, {
    method: 'DELETE'
  });
}

export async function updateDoohReportName(lineItemId: string, name: string): Promise<{ name: string }> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}doohReport/${lineItemId}/name`, {
    data: { name },
    method: 'PATCH'
  });
}
